import { createTopic, ConfigActions } from '../lib';
import { z } from 'zod';

const teamRolesOnboardedEventSchema = z.object({
  subject: z
    .string()
    .describe('The subject (user or group) who onboarded the project.'),
  entityUrn: z.string().describe('The URN of the entity that was onboarded.'),
  isManuallyOnboarded: z
    .boolean()
    .describe('Whether the project was manually onboarded.'),
});

export type TeamRolesOnboardedEvent = z.infer<
  typeof teamRolesOnboardedEventSchema
>;

export const teamRolesOnboardedTopic = createTopic<TeamRolesOnboardedEvent>(
  {
    namespace: 'control-plane',
    name: 'team-roles-onboarded',
    description: 'User onboarded an existing project to team roles management',
  },
  teamRolesOnboardedEventSchema,
  s => [
    { action: ConfigActions.HASH, path: s.subject },
    { action: ConfigActions.HASH, path: s.entityUrn },
  ],
);
